import { createContext } from 'react';

export const Context = createContext({
	commerce: null,
	products: null,
	numOfItemsInCart: null,
	setNumOfItemsInCart: () => {}
});
